module.exports = __webpack_public_path__ + "img/d2653f7.jpg";